import { render, staticRenderFns } from "./platformstation.vue?vue&type=template&id=5a00885e&scoped=true&"
import script from "./platformstation.vue?vue&type=script&lang=js&"
export * from "./platformstation.vue?vue&type=script&lang=js&"
import style0 from "./platformstation.vue?vue&type=style&index=0&id=5a00885e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00885e",
  null
  
)

export default component.exports